// 申込処理中止
import React from 'react';
import { createRoot } from 'react-dom/client';
import Block from '../molecules/Block';

const ReceptionAbort: React.FC = () => {
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="申込処理を中止しました。"
        content={
          <p>
            申込処理を中止しました。
            <br />
            再開する場合は、通知されたメールのURLよりアクセスしてください。
          </p>
        }
      />
    </>
  );
};

const container = document.getElementById('reception-abort');
if (container) {
  const root = createRoot(container);
  root.render(<ReceptionAbort />);
}
